import renderMediaQuery from "@suid/css/renderMediaQuery";
export const breakpointsDefault = createBreakpointsOptions({
    columns: 12,
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
    },
    unit: "px",
});
export function createBreakpointsOptions(options) {
    return options;
}
export function createBreakpoints(options) {
    const result = {
        ...breakpointsDefault,
        ...(options ?? {}),
        up: (value, css) => {
            const key = renderMediaQuery("up", result.resolve(value));
            return (css ? { [key]: css } : key);
        },
        down: (value, css) => {
            const key = renderMediaQuery("down", result.resolve(value));
            return (css ? { [key]: css } : key);
        },
        between: (value, css) => {
            const key = renderMediaQuery("between", [
                result.resolve(value[0]),
                result.resolve(value[1]),
            ]);
            return (css ? { [key]: css } : key);
        },
        resolve: (value) => typeof value === "number" ? value : result.values[value],
    };
    return result;
}
export default createBreakpoints;
